import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { ClipboardText } from "@phosphor-icons/react";

const ACTION_COLORS = {
  "login": "text-slate-600",
  "logout": "text-slate-500",
  "import.uploaded": "text-blue-700",
  "batch.committed": "text-emerald-700",
  "party.created": "text-emerald-700",
  "template.assigned": "text-emerald-700",
  "template.changed": "text-amber-700",
  "invoices.generated": "text-emerald-700",
  "distribution.regenerated": "text-amber-700",
  "invoice.approved": "text-emerald-700",
  "invoice.rejected": "text-rose-700",
  "invoice.voided": "text-rose-700",
  "invoice.pdf_downloaded": "text-slate-600",
  "settings.updated": "text-amber-700",
  "user.created": "text-emerald-700",
  "user.deactivated": "text-rose-700",
};

export default function AuditPage() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  const load = () => api.get("/audit", { params: q ? { action: q } : {} }).then((r) => setRows(r.data));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="p-8 space-y-6">
      <div>
        <h1 className="font-display text-3xl font-bold text-slate-900 flex items-center gap-2">
          <ClipboardText size={26} weight="duotone" /> Audit Log
        </h1>
        <p className="text-sm text-muted-foreground mt-1">Immutable record of every important action.</p>
      </div>

      <div className="flex gap-2">
        <Input placeholder="Filter by action (e.g. invoice.approved)" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} data-testid="audit-filter" />
      </div>

      <div className="card-panel">
        <table className="w-full table-dense" data-testid="audit-table">
          <thead className="bg-muted/60">
            <tr>
              <th className="text-left">When</th>
              <th className="text-left">User</th>
              <th className="text-left">Action</th>
              <th className="text-left">Entity</th>
              <th className="text-left">Reason / Meta</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-border/60 hover:bg-muted/40">
                <td className="text-xs text-muted-foreground">{new Date(r.created_at).toLocaleString()}</td>
                <td className="text-xs">{r.user_email || "—"} <span className="text-muted-foreground">({r.user_role || "—"})</span></td>
                <td className={`text-xs font-medium ${ACTION_COLORS[r.action] || "text-slate-700"}`}>{r.action}</td>
                <td className="text-xs">{r.entity_type ? `${r.entity_type}:${r.entity_id?.substring(0, 8) || ""}` : "—"}</td>
                <td className="text-xs text-muted-foreground max-w-md truncate">{r.reason || JSON.stringify(r.meta || {})}</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan="5" className="text-center py-10 text-muted-foreground">No audit entries.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
